import type { SelfAssessmentPlacement, SelfAssessmentStep } from "~/classes/models/self-assessment/self-assessment-step.model";

type PlacementConfig = Pick<SelfAssessmentStep, "placementValidation" | "placementValidations">;

export const getPlacementValidations = (step: PlacementConfig): SelfAssessmentPlacement[] => {
  // An explicitly empty array means unrestricted placement, not legacy fallback.
  if (Array.isArray(step.placementValidations)) return [...new Set(step.placementValidations)];
  if (step.placementValidation === "titleAndLastSentence") return ["title", "lastSentence"];
  return step.placementValidation ? [step.placementValidation] : [];
};

export const hasOnlyPlacement = (step: PlacementConfig, placement: SelfAssessmentPlacement) => {
  const placements = getPlacementValidations(step);
  return placements.length === 1 && placements[0] === placement;
};

export const hasOnlyBoundaryPlacements = (step: PlacementConfig) => {
  const placements = getPlacementValidations(step);
  return placements.length > 0 && placements.every(placement =>
    placement === "introductionParagraph" || placement === "conclusionParagraph"
  );
};

export const getPlacementParagraphPositions = (placement: SelfAssessmentPlacement, positions: number[]) => {
  if (positions.length === 0) return [];
  if (placement === "introductionParagraph") return [positions[0]];
  if (placement === "conclusionParagraph") return [positions[positions.length - 1]];
  return positions;
};

export const getStepPlacementParagraphPositions = (step: PlacementConfig, positions: number[]) => {
  const placements = getPlacementValidations(step);
  if (placements.length === 0) return positions;
  const allowed = new Set(placements.flatMap(placement => getPlacementParagraphPositions(placement, positions)));
  return positions.filter(position => allowed.has(position));
};
